/**
 * Payment webhook + Finance Hub connection copy for Integrations.
 * Spread into en.ts with the other payment slices.
 */
import { enPaymentConnectors } from './enPaymentConnectors';
import { enPaymentProviders } from './enPaymentProviders';

export const enPaymentTiles = {
  ...enPaymentConnectors,
  ...enPaymentProviders,

  'tile.paymentWebhook.name': 'Payment webhook (PayPal, Grow, Tranzila)',
  'tile.paymentWebhook.description': 'One signed notify URL for any processor BuzzBit has no adapter for, or a Make/Zapier step',
  'paymentWebhook.howTo': 'Paste the notify URL into PayPal (IPN), Grow / Meshulam or Tranzila, or into your Make/Zapier step, and sign every POST with the secret. Each payment lands on the ledger and the order.',
  'paymentWebhook.webhookUrl': 'Notify URL',
  'paymentWebhook.providers': 'Works with',
  'paymentWebhook.providerList': 'PayPal · Grow (Meshulam) · Tranzila · PayPlus · Make / Zapier / n8n',
  'paymentWebhook.eventTypes': 'Event types',
  'paymentWebhook.eventTypeList': 'payment_received · payment_failed · payment_refunded · subscription_started · subscription_renewed · subscription_cancelled · trial_started · trial_ending · plan_changed',
  'paymentWebhook.signature': 'Signature header',
  'paymentWebhook.connected': 'Secret set',
  'paymentWebhook.generate': 'Generate secret',
  'paymentWebhook.rotate': 'Rotate secret',
  'paymentWebhook.rotateConfirm': 'Rotate the secret? The old one stops verifying immediately — update your processor right after.',
  'paymentWebhook.generatedLabel': 'Signing secret',
  'paymentWebhook.generatedOnce': 'Shown once. Copy it now — it cannot be shown again.',
  'paymentWebhook.saved': 'Payment webhook secret ready.',
  'paymentWebhook.failed': 'Could not mint the secret. Try again in a minute.',

  'tile.paymentConnections.name': 'Payment connections',
  'tile.paymentConnections.description': 'A signed webhook per processor; payments, refunds and fees land on the Finance ledger',
  'paymentConnections.howTo': 'Each connection gets its own webhook URL and secret. Your processor, or a Make/Zapier step, posts payments, refunds, payouts and fees to it and they land on the ledger.',
  'paymentConnections.listTitle': 'Connections',
  'paymentConnections.empty': 'No connections yet',
  'paymentConnections.labelField': 'Label',
  'paymentConnections.labelPlaceholder': 'e.g. Tranzila terminal',
  'paymentConnections.add': 'Add connection',
  'paymentConnections.created': 'Connection created.',
  'paymentConnections.failed': 'Could not create the connection. Try again in a minute.',
  'paymentConnections.loadFailed': 'Could not load the connections.',
  'paymentConnections.webhookUrl': 'Webhook URL',
  'paymentConnections.secret': 'Signing secret',
  'paymentConnections.secretOnce': 'Shown once. Copy it now — it cannot be shown again.',
  'paymentConnections.signature': 'Signature header',
  'paymentConnections.signatureFormat': 'X-BuzzBit-Signature: t=<unix seconds>,v1=<hex HMAC-SHA256(secret, t + "." + body)>',
  'paymentConnections.provider.generic': 'Signed webhook',
  'paymentConnections.status.PENDING': 'Pending',
  'paymentConnections.status.ACTIVE': 'Active',
  'paymentConnections.status.ERROR': 'Error',
  'paymentConnections.status.DISCONNECTED': 'Disconnected',
  'paymentConnections.lastSync': 'Last event {when}',
  'paymentConnections.lastError': 'Last error: {error}',
} as const;
